import { getDomainConfig, getLocale } from '@raisin/cp-utils';
export const nlMenus = (logoUrl) => {
    const basePath = getDomainConfig(getLocale('nl-NL').cmsFormat).basePath;
    return {
        type: 'public',
        logoItems: [
            {
                id: '3f7573d4-7cce-42d0-8263-f0d9079e2b11',
                href: `${basePath}/`,
                url: logoUrl,
                alt: 'Raisin',
            },
        ],
        navItems: [
            {
                id: '7c70fbcc-4e00-4fe1-8b47-87251d3534b5',
                title: 'Producten',
                href: '',
                subMenus: {
                    main: [
                        {
                            id: '9d42c71e-7190-4618-b581-38951fbcf547',
                            type: 'advanced',
                            title: 'Deposito sparen',
                            href: `${basePath}/deposito/`,
                            icon: 'fixedDepositIcon',
                            iconColor: '#61AFD2',
                        },
                        {
                            id: '76d1f169-c6a1-495e-a495-5fcc74f131ca',
                            type: 'advanced',
                            title: 'Spaarrekening',
                            href: `${basePath}/spaarrekening/`,
                            icon: 'overnightMoneyIcon',
                            iconColor: '#9CD3E4',
                        },
                    ],
                },
            },
            {
                id: '36e9994f-8c35-4d1c-a470-fab6ad144699',
                title: 'Informatie',
                href: '',
                subMenus: {
                    main: [
                        {
                            id: 'd71e82d5-84ea-4457-8cfc-762927bd8f21',
                            type: 'advanced',
                            icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt8e96e15c429c928b/Einlagensicherung.svg',
                            iconColor: '#0E6CC5',
                            title: 'Depositogarantie',
                            href: `${basePath}/depositogarantie/`,
                        },
                        {
                            id: '4a17825e-a704-457c-945f-f1b45c50b29e',
                            type: 'advanced',
                            icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt30ff10945458f646/Belasting.svg',
                            iconColor: '#0E6CC5',
                            title: 'Belasting',
                            href: `${basePath}/belasting/`,
                        },
                        {
                            id: '8ec5d1d0-2452-4cad-acce-f8875f8b8277',
                            type: 'advanced',
                            icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt99996be20b268bc3/Sparen_algemeen.svg',
                            iconColor: '#0E6CC5',
                            title: 'Sparen algemeen',
                            href: `${basePath}/sparen/`,
                        },
                        {
                            id: '023386ad-c47a-44cd-be66-4ea80d25ca22',
                            type: 'advanced',
                            icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blte084bc080dd2c186/Sparen_in_de_EU.svg',
                            iconColor: '#0E6CC5',
                            title: 'Sparen in de EU',
                            href: `${basePath}/spaarrente/buitenland/`,
                        },
                    ],
                    sidebar: [
                        {
                            id: 'e776ab43-cce8-4cb1-9660-f10521d72340',
                            type: 'arrow',
                            title: 'Hoeveel sparen?',
                            href: `${basePath}/sparen/hoeveel-sparen/`,
                        },
                        {
                            id: '5330f3cf-1ecb-4689-b50f-83ca4fa184e8',
                            type: 'arrow',
                            title: 'Wat te doen met spaargeld?',
                            href: `${basePath}/sparen/wat-te-doen-met-spaargeld/`,
                        },
                        {
                            id: 'b8401a9d-2cfb-4280-b7ad-d54ee8c31d7e',
                            type: 'arrow',
                            title: 'Sparen of beleggen?',
                            href: `${basePath}/sparen/of-beleggen/`,
                        },
                        {
                            id: 'e576ab43-cce8-4cb1-9660-f10521d72340',
                            type: 'arrow',
                            title: 'Sparen of aflossen?',
                            href: `${basePath}/sparen/of-aflossen/`,
                        },
                    ],
                },
            },
            {
                id: 'f149e12f-3a9f-44e3-a75e-ae1a37e12c64',
                title: 'Over Raisin',
                href: '',
                subMenus: {
                    main: [
                        {
                            id: 'e78780a1-cc15-45d9-95ca-53c52e905cc5',
                            type: 'advanced',
                            icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt8a5863614d18d6bc/Zo_werkt_het.svg',
                            iconColor: '#0E6CC5',
                            title: 'Zo werkt het',
                            href: `${basePath}/zo-werkt-het/`,
                        },
                        {
                            id: 'e78780a1-cc15-45d9-95ca-53c52e905cc2',
                            type: 'advanced',
                            icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/bltb30f24c72431a3ba/Partnerbanken.svg',
                            iconColor: '#0E6CC5',
                            title: 'Partnerbanken',
                            href: `${basePath}/banken/`,
                        },
                        {
                            id: 'e78780a1-cc15-45d9-95ca-53c52e905cc1',
                            type: 'advanced',
                            icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt7306ae38b600c7e6/Over_ons.svg',
                            iconColor: '#0E6CC5',
                            title: 'Over ons',
                            href: `${basePath}/over-raisin`,
                        },
                    ],
                },
            },
            {
                id: 'b1ef9202-f58c-4f98-a3fe-b4178a842ecb',
                title: 'Service & Contact',
                href: `${basePath}/service-en-contact/`,
            },
        ],
        actionItems: [
            {
                id: '659be2f1-cdfa-4666-bcbb-edf874ad83ce',
                title: 'Mijn account',
                href: `${basePath}/login/`,
                type: 'login',
            },
            {
                id: 'fc1573f6-a151-4299-aaef-0e1b375227ba',
                title: 'Word klant',
                href: `${basePath}/register/`,
                type: 'registration',
            },
        ],
    };
};
//# sourceMappingURL=nlMenus.js.map